// extracted by mini-css-extract-plugin
module.exports = {"tally-container":"TallyMarks_tally-container__3F9iR","button-container":"TallyMarks_button-container__29mp6"};